/*
    Class HoverCursorManager
    Manages the hover of the cursor on a gallery
    Params : {
        container: {DOM} container of the gallery,
        gallery : {
            classesName: {
                items: {STRING} className of the item of the gallery
                icons: {STRING} className of the icon
            }
        }
    }
*/

export default class HoverCursorManager {

    _incrementScroll = 0;
    _isHover = false;
    _oldScroll = false;
    _classNameLinkIcon = 'js-download-link';
    _indexItemGallery = 0;

    _posDownloadButton = {
        x : 0,
        y : 0
    };

    _posItemGallery = {
        top : 0,
        left : 0
    };

    constructor( { container = false, gallery = { classesName : { items, icons} } } = {} ) {

        this.dom = {};

        this.dom.container = container;

        this._galleryClassesName = {
            items: gallery.classesName.items || false,
            icons: gallery.classesName.icons || false,
        };

        if (this.dom.container) {
            this.retrieveDOM();
            this._bind();
        }
    }

    retrieveDOM() {

        this.dom.gallery = {
            items : [].slice.call( this.dom.container.querySelectorAll('.' + this._galleryClassesName.items) ),
            itemsWithIcon : [],
            icons: [].slice.call( this.dom.container.querySelectorAll('.' + this._galleryClassesName.icons) )
        }

        /** Get only the links that contain an icon of the type "download" **/
        for ( let i = 0, j = this.dom.gallery.items.length; i < j; i++ ) {
            let item = this.dom.gallery.items[i];
            if( item.querySelector('.' + this._galleryClassesName.icons) ) {
                item.classList.add( this._classNameLinkIcon );
                this.dom.gallery.itemsWithIcon.push( item );
            }
        }

        /** Get half the size of the icon **/
        if( this.dom.gallery.icons.length > 0 ) {
            let iconStyles = window.getComputedStyle( this.dom.gallery.icons[0] );
            let iconWidth = parseInt( iconStyles.getPropertyValue('width').split('px')[0] );
            this._iconHalfSize = iconWidth / 2;
        }
    }

    _bind() {

        /** Entry and exit event on each link **/
        if( this.dom.gallery.items.length > 0 ) {
            delegate(this.dom.container, '.'+ this._galleryClassesName.items, 'mouseenter', this._enterItemGallery.bind(this), true);
            delegate(this.dom.container, '.'+ this._galleryClassesName.items, 'mouseleave', this._leaveItemGallery.bind(this), true);
        }

        /** Move event only on the "icon" link : Do not check if "download" types exist because they may be absent at the start and then arrive with "load more" **/
        // if( this.dom.gallery.itemsWithIcon.length > 0 ) {
            delegate(this.dom.container, '.'+ this._classNameLinkIcon, 'mousemove', this._moveItemGallery.bind(this), true);
        // }
    }

    /**
     * Called when the user enters the area of a link
     */
    _enterItemGallery( event ) {

        this._isHover = true;

        let target = event.delegateTarget;
        this._indexItemGallery = this.dom.gallery.items.indexOf( target );

        /** Check if the link is of type "icon" **/
        this._iconExist = false;
        if( target.classList.contains( this._classNameLinkIcon ) ) {
            this._indexIcon = this.dom.gallery.itemsWithIcon.indexOf( target );
            this._iconExist  = true;
        }

        /** If it is an "icon" link: display the icon **/
        if( this._iconExist  ) {
            this._getPositionItem();
            TweenMax.to( this.dom.gallery.icons[ this._indexIcon ], 0.2, { scale : 1, autoAlpha: 1 } )
        }

        /** Hide others links **/
        for ( let i = 0, j = this.dom.gallery.items.length; i < j; i++ ) {
            if( i != this._indexItemGallery ) {
                this.dom.gallery.items[i].classList.add('hide')
            }
        }
    }

    /**
     * Called when the user moves inside an "icon" link
     */
    _moveItemGallery( event ) {

        /** Position x and y of the cursor **/
        let cursor = {
            x : event.clientX,
            y : event.clientY
        };

        /** The position of the icon (top / left) = position of the cursor - the distance of the link from the window - half the size of the icon **/
        this._posDownloadButton = {
            x : cursor.x - this._posItemGallery.left - this._iconHalfSize,
            y : cursor.y - this._posItemGallery.top - this._iconHalfSize
        };

        TweenMax.to( this.dom.gallery.icons[ this._indexIcon ], 0, { x : this._posDownloadButton.x, y : this._posDownloadButton.y } )
    }

    /**
     * Called when the user leaves the area of a link
     */
    _leaveItemGallery( event ) {

        this._isHover = false;

        /** If it is an "icon" link: hide the icon **/
        if( this._iconExist  ) {
            TweenMax.to( this.dom.gallery.icons[ this._indexIcon ], 0.2, { scale : 0, autoAlpha: 0 } );
        }

        /** Show others links **/
        for ( let i = 0, j = this.dom.gallery.items.length; i < j; i++ ) {
            this.dom.gallery.items[i].classList.remove('hide')
        }
    }

    /**
     * Called when the user scrolls in the page
     */
    update( pos ) {

        /** If the user is on a link + the link is of type "icon" + "oldScroll" is a numeric value **/
        if( this._isHover && this._iconExist && this._oldScroll ) {
            this._getPositionItem();

            let incrementScroll = pos - this._oldScroll;
            this._posDownloadButton.y += incrementScroll;
            TweenMax.to( this.dom.gallery.icons[ this._indexIcon ], 0, { x : this._posDownloadButton.x, y : this._posDownloadButton.y } )
        }

        this._oldScroll = pos;
    }

    /**
     * Retrieve the position of the link from the top and left edges of the window
     */
    _getPositionItem() {

        this._posItemGallery = {
            top: this.dom.gallery.items[this._indexItemGallery].getBoundingClientRect().top,
            left: this.dom.gallery.items[this._indexItemGallery].getBoundingClientRect().left
        };
    }
}


// WEBPACK FOOTER //
// src/js/helpers/hover-cursor-manager.js